module.exports = __webpack_public_path__ + "static/img/mini-icon.f9a696c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mini-icon.jpg
// module id = goHf
// module chunks = 0